module.exports = __webpack_public_path__ + "static/po-intro-img-2-5633be5a8b772ae74c4af2d6b82ad62c.png";